export const SET_CONFIG = 'SET_CONFIG';

export const SET_LANGUAGES = 'SET_LANGUAGES';

export const TOSS_STANDARD_AUTH = 'TOSS_STANDARD_AUTH';



// WEBPACK FOOTER //
// ./node_modules/eslint-loader!./src/store/constants.ts